export default __webpack_public_path__ + "static/media/Hilda.062d01e5.jpg";